import { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';

const REFERRAL_SOURCE_USER = 'referral_src_usr';
const SHOW_SNACK_BAR = 'show_snack_bar';


export default function useReferralSource() {
  const [hasMounted, setHasMounted] = useState(false);
  const location = useLocation();
  const urlParams = useParams();
  const searchParams = new URLSearchParams(location.search);
  const showSnackBarParam = searchParams.get('showSnackBar');
  const deeplinkPath = '/bella/deeplink';


  // This function is used to clear session storage
  // after an appointment has been booked and confirmed
  const resetReferralUser = () => {
    sessionStorage.removeItem(REFERRAL_SOURCE_USER);
    sessionStorage.removeItem(SHOW_SNACK_BAR);
  }
  
  const resetShowSnackBar = () => {
    sessionStorage.removeItem(SHOW_SNACK_BAR);
  }
 

  useEffect(() =>{
    if(showSnackBarParam === 'true' && location.pathname === deeplinkPath) {
      sessionStorage.setItem(SHOW_SNACK_BAR, 'true');
    }
   
  },[deeplinkPath])

  useEffect(() => {
    if (!hasMounted) {
      setHasMounted(true);
      const referralUrlMatch = new RegExp('\/referral\/*').test(location.pathname);
      if (location.pathname === '/welcome' || (new RegExp('\/series\/*').test(location.pathname))) {
        resetReferralUser();
      }
      else if (referralUrlMatch && !!urlParams.shortId) {
        const isReferralSource = referralUrlMatch && !!urlParams.shortId;
        sessionStorage.setItem(REFERRAL_SOURCE_USER, isReferralSource);
      }
    }
  }, [
    hasMounted,
    urlParams?.shortId,
    location.pathname
  ]);

  return {
    isReferralSource: sessionStorage.getItem(REFERRAL_SOURCE_USER) === "true",
    resetReferralUser,
    showSnackBar: sessionStorage.getItem(SHOW_SNACK_BAR) === 'true',
    resetShowSnackBar,
  };
}
